module.exports = __webpack_public_path__ + "static/RivieraNights-Ultralight-ab0850bf5938b1cb126d3c5b787b12bf.woff2";